import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  class: "meeting-recording-symbol",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "meeting-recording-copy" }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.capture || _ctx.unavailable)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        title: _ctx.description,
        class: "meeting-recording-status",
        role: "status",
        "aria-live": "polite"
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.capture?.status === 'processing' ? '◷' : '●'), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1),
          (_ctx.capture?.status === 'processing' && _ctx.capture.stage)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.capture.stage), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.capture)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: '/ai-review/' + _ctx.capture.jobId
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.capture.status === 'processing' ? 'View progress' : _ctx.capture.notesReady ? 'View notes & transcript' : 'Open recording'), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)))
            }, "Try again"))
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}